import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDBox } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

const InflowsMoneyFlowsSectionLayout = () => {
  const isMobile = useMobileLayout();
  return (
    <FDBox width={'100%'} paddingY={isMobile ? 2 : 6}>
      <MetaControlField attr={'moneyFlows'} />
    </FDBox>
  );
};

InflowsMoneyFlowsSectionLayout.defaultProps = {};

InflowsMoneyFlowsSectionLayout.propTypes = {};

export default InflowsMoneyFlowsSectionLayout;
